/**
 * Totaux de ligne sur la période affichée (colonne « Total » du tableau cash-flow).
 *
 * Réel : somme des mois écoulés uniquement (un mois futur n'a pas de réel).
 * Prévi : somme de tous les mois affichés.
 * Montants HT quand disponibles, sinon TTC — même règle que les cellules.
 * Renvoie null quand aucune période ne contribue, pour afficher « — ».
 *
 * @param {Array}  perPeriod  entrées { period_start, [prefix]actual_cents, [prefix]actual_ht_cents, ... }
 * @param {Array}  cols       colonnes affichées { period_start, is_future }
 * @param {string} [prefix]   '' (cumul / catégories) ou 'section_' (total de section)
 * @returns {{ actual: number|null, forecast: number|null }}
 */
export function sumPeriodTotals(perPeriod, cols, prefix = '') {
  const byStart = new Map((perPeriod ?? []).map((p) => [p.period_start, p]));
  let actual = null;
  let forecast = null;
  for (const col of cols) {
    const pp = byStart.get(col.period_start);
    if (!pp) continue;
    if (!col.is_future) {
      const a = pp[`${prefix}actual_ht_cents`] ?? pp[`${prefix}actual_cents`] ?? null;
      if (a != null) actual = (actual ?? 0) + a;
    }
    const f = pp[`${prefix}forecast_ht_cents`] ?? pp[`${prefix}forecast_cents`] ?? null;
    if (f != null) forecast = (forecast ?? 0) + f;
  }
  return { actual, forecast };
}
